/* eslint-disable react/no-unescaped-entities */
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import pimg from "../../assets/vitt-vichaar/plus.webp";
import sessionImg from "../../assets/vitt-vichaar/sessions_text.webp";

export default function Plus() {
  const [ref0, inView0] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref1, inView1] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref2, inView2] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const [ref3, inView3] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <>
      <section className="text-center lg:text-left lg:pt-20 lg:pb-12 ">
        <div className=" lg:text-center text-left xl:px-32 ">
          <div className="grid items-center lg:grid-cols-2 ">
            <div className="">
              <div className="relative z-[1] block lg:rounded-lg bg-[hsla(0,0%,100%,0.55)] px-4 pb-4 pt-8 lg:px-6 lg:py-12 dark:bg-theme_2 dark:shadow-black/20 md:px-12 lg:-mr-14 backdrop-blur-[30px] shadow-lg">
                <img
                  src={sessionImg}
                  alt="session & collaborations"
                  className="w-[90%] text-center"
                />
                <p
                  className="mb-12 text-neutral-500 text-sm lg:text-[18px]"
                  ref={ref0}
                >
                  <span className="block py-2 flex justify-between">
                    <span>Aadhaar Card Camp, Gurugram Beneficiaries:</span>
                    <strong>
                      {inView0 && <CountUp end={40} duration={2} />}+ People
                    </strong>
                  </span>

                  <span className="block py-2 flex justify-between">
                    <span>NSS , Sri Venkateswara College Beneficiaries :</span>
                    <strong>
                      {inView0 && <CountUp end={60} duration={2} />}+ People
                    </strong>
                  </span>

                  <span className="block py-2 flex justify-between">
                    <span>Enactus, Satyawati College Beneficiaries:</span>
                    <strong>
                      {inView0 && <CountUp end={60} duration={2} />}+ People
                    </strong>
                  </span>

                  <span className="block py-2 flex justify-between">
                    <span>Kendriya Vidyalaya, JMI Beneficiaries:</span>
                    <strong>
                      {inView0 && <CountUp end={70} duration={2} />}+ People
                    </strong>
                  </span>

                  <span className="block py-2 flex justify-between">
                    <span>Saheed Anusuya Public School Beneficiaries:</span>
                    <strong>
                      {inView0 && <CountUp end={90} duration={2} />}+ People
                    </strong>
                  </span>

                  <span className="block py-2 flex justify-between">
                    <span>CDF , Motilal Nehru College Beneficiaries:</span>
                    <strong>
                      {inView0 && <CountUp end={40} duration={2} />}+ People
                    </strong>
                  </span>
                </p>

                <div className="grid gap-x-6 md:grid-cols-3 text-center">
                  <div className="mb-12 md:mb-0">
                    <div
                      ref={ref1}
                      className="text-theme_4 mb-2 text-3xl font-bold text-[#F6BB33]"
                    >
                      {inView1 && <CountUp end={20} duration={2} />}+
                    </div>
                    <h5 className="mb-0 text-lg font-semibold text-[#257377]">
                      Ventures
                    </h5>
                  </div>

                  <div className="mb-12 md:mb-0">
                    <div
                      ref={ref2}
                      className="text-theme_4 mb-2 text-3xl font-bold text-[#F6BB33]"
                    >
                      {inView2 && <CountUp end={2500} duration={2} />}+
                    </div>
                    <h5 className="mb-0 text-lg font-semibold text-[#257377]">
                      Beneficiaries
                    </h5>
                  </div>

                  <div className="mb-12 md:mb-0">
                    <div
                      ref={ref3}
                      className="text-theme_4 mb-2 text-3xl font-bold text-[#F6BB33]"
                    >
                      Jan&nbsp;
                      {inView3 && <CountUp end={21} duration={2} />}
                    </div>
                    <h5 className="mb-0 text-lg font-semibold text-[#257377]">
                      Launched
                    </h5>
                  </div>
                </div>
                <br />
              </div>
            </div>

            <div>
              <img
                src={pimg}
                className="hidden lg:block w-[30rem] shadow-lg dark:shadow-black/20"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
